import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root',
})
export class CepService {
  private _apiService = inject(ApiService);
  private _urlService = inject(UrlService);

  payload: any;

  postCreditoCep(payload: any): Observable<any> {
    const url = this._urlService.getApiCreditoCep();

    return this._apiService.post(url, payload);
  }
}
